<template>
  <v-container
    class="no-commercial-box-container no-padding"
    :style="{ border: '4px solid ' + color }"
  >
    <v-row class="firstrow" v-if="showData">
      <v-col cols="12" sm="6">
        <userdata :isSupport="false"></userdata>
      </v-col>
      <v-col cols="12" sm="6" class="secondrow-col" v-if="showRequest">
        <div class="maintitle request">{{ $t("Support.request") }}</div>
        <inputForm
          :showTerm="true"
          v-on:emailSent="emailSent()"
          :email="defaultRecipient"
          :isInQuotations="true"
          :division="division"
        ></inputForm>
      </v-col>
    </v-row>

    <div class="email-sent" v-if="showSuccess">
      <div class="img-container">
        <img src="@/assets/check_Tavola.png" class="check-img" />
      </div>
      <div class="msg-container">
        {{ $t("Support.request_sent") }}
      </div>
      <div class="btn-container">
        <v-btn class="generic-button" @click="clearRequest()">
          {{ $t("Misc.RequestQuotation") }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
<style>
.no-commercial-box-container .input-form-container {
  display: block;
}

.quotations-main .no-commercial-box-container .textarea-col .textarea {
  margin-top: 0;
  height: 290px;
}

.quotations-main .no-commercial-box-container .company-col {
  padding-left: 57px;
}

.no-commercial-box-container .secondrow-col {
  padding-left: 25px;
  padding-right: 57px;
  padding-top: 56px;
}

.no-commercial-box-container .email-sent .msg-container {
  font: normal normal bold 20px/24px Lato;
  color: #707070;
}

@media (max-width: 600px) {
  .no-commercial-box-container {
    height: 760px !important;
    border-radius: 20px !important;
  }

  .no-commercial-box-container .row.firstrow {
    height: auto;
    margin: 0px;
  }

  .no-commercial-box-container .row.firstrow .first-col {
    padding-bottom: 0;
  }

  .no-commercial-box-container .maintitle {
    font: normal normal bold 20px/24px Lato;
    letter-spacing: 0px;
    color: #5d6367;
  }

  .no-commercial-box-container .company-col {
    padding-top: 0;
  }

  .no-commercial-box-container .company-col .maintitle {
    padding-top: 24px;
  }

  .quotations-main .no-commercial-box-container .textarea-col .textarea {
    margin-top: 0;
    height: 200px;
  }

  .no-commercial-box-container .requestrow .v-input {
    padding-left: 0px;
  }

  .no-commercial-box-container .userdata-container {
    padding-bottom: 0px !important;
    border-radius: 0px !important;
    box-shadow: unset !important;
  }

  .no-commercial-box-container .userdata-container .bar-div {
    width: 285px;
  }

  .no-commercial-box-container .userdata-container .company-col .text {
    padding-top: 0px;
  }

  .no-commercial-box-container .secondrow-col.col-sm-6.col-12 {
    padding-top: 0px;
  }

  .no-commercial-box-container .secondrow-col {
    padding-left: 25px;
    padding-right: 25px;
  }
}

/* .no-commercial-box-container .userdata-container .company-col {
  border-left: 2px solid #707070;
  border-right: 2px solid #707070;
  position: relative;
} */

@media (max-width: 600px) {
  .quotations-main .no-commercial-box-container {
    border-width: 4px !important;
  }

  .no-commercial-box-container .userdata-container .company-col {
    border: none;
  }

  .quotations-main .no-commercial-box-container .row.firstrow {
    padding: 0;
  }

  .quotations-main .no-commercial-box-container .row.requestrow .requestcol {
    padding-left: 26px;
    padding-right: 26px;
  }

  .quotations-main .no-commercial-box-container .row.firstrow .first-col,
  .quotations-main .no-commercial-box-container .row.firstrow .company-col {
    padding-left: 23px;
    padding-right: 23px;
  }

  .quotations-main .no-commercial-box-container .maintitle {
    font: normal normal bold 20px/24px Roboto;
  }

  .quotations-main .no-commercial-box-container .maintitle.request {
    display: none;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import MDApi from "../api/MD/MDApi.js";
import inputForm from "./inputForm.vue";
import userdata from "./userData.vue";

export default {
  props: {
    color: String,
    division: String,
  },

  components: {
    inputForm,
    userdata,
  },

  data() {
    return {
      showRequest: true,
      showData: true,
      showSuccess: false,
      term: false,
      term_warning: false,
      request: "",
      isMobile: false,
      user: null,
      defaultRecipient: process.env.VUE_APP_EMAIL_RECIPIENT,
      reference_data: {
        name: "",
        surname: "",
        email: "",
      },
      company_data: {
        name: "",
        street: "",
        zipcode: "",
        locality: "",
        nation: "",
        code: "",
      },
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();

    this.user = this.$GAUserAuth.user;
    this.reference_data.name = this.user.firstname;
    this.reference_data.surname = this.user.lastname;
    this.reference_data.email = this.user.username;

    let companyCode = this.user.companyCode;

    MDApi.GetCompanyData(companyCode).then((res) => {
      if (res.data) {
        this.company_data.name = res.data.Name;
        this.company_data.street = res.data.Address;
        this.company_data.zicode = res.data.ZipCode;
        this.company_data.locality = res.data.City;
        this.company_data.nation = res.data.CountryDescription;
        this.company_data.phone = res.data.AccountingPhone;
        this.company_data.code = res.data.AltKN;
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  mounted() {
    this.$emit("created", true);
  },

  methods: {
    emailSent() {
      this.showSuccessDiv();
    },
    clearRequest() {
      this.showData = true;
      this.showSuccess = false;
      this.showRequest = true;
      this.request = "";
      this.term_warning = false;
      this.term = false;
    },

    showSuccessDiv() {
      if (!this.isMobile) this.showData = false;
      else this.showData = true;

      this.showRequest = false;

      this.showSuccess = true;
      this.request = "";
      this.term_warning = false;
      this.term = false;
      this.mail_sent = true;
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>